"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchOrdersByStoreIdAndWalletAddress = exports.fetchOrderByTokenMintAndShopId = exports.fetchOrderByTokenMint = exports.fetchOrdersByStoreId = void 0;
const candy_shop_types_1 = require("@liqnft/candy-shop-types");
const qs_1 = __importDefault(require("qs"));
async function fetchOrdersByStoreId(axiosInstance, storeId, ordersFilterQuery) {
    const { sortBy, offset, limit, identifiers, sellerAddress, candyShopAddress, attribute: attributeQuery, collectionId, nftName } = ordersFilterQuery;
    let queryParams = {};
    let attribute = undefined;
    if (attributeQuery) {
        const attributes = Array.isArray(attributeQuery) ? attributeQuery : [attributeQuery];
        attribute = attributes.map((attr) => {
            const entry = Object.entries(attr)[0];
            return { trait_type: entry[0], value: entry[1] };
        });
    }
    console.log(`CandyShop: fetching orders from ${storeId}`, { query: ordersFilterQuery });
    if (sortBy) {
        const arrSortBy = Array.isArray(sortBy) ? sortBy : [sortBy];
        queryParams.orderByArr = arrSortBy.map((sort) => JSON.stringify(sort));
    }
    if (offset) {
        queryParams.offset = offset;
    }
    if (limit) {
        queryParams.limit = limit;
    }
    if (identifiers && identifiers.length !== 0) {
        queryParams['filterArr[]'] = identifiers.map((identifier) => JSON.stringify({
            side: candy_shop_types_1.Side.SELL,
            status: candy_shop_types_1.Status.OPEN,
            identifier,
            walletAddress: sellerAddress,
            candyShopAddress,
            attribute,
            collectionId,
            nftName
        }));
    }
    else {
        queryParams['filterArr[]'] = JSON.stringify({
            side: candy_shop_types_1.Side.SELL,
            status: candy_shop_types_1.Status.OPEN,
            walletAddress: sellerAddress,
            candyShopAddress,
            attribute,
            collectionId,
            nftName
        });
    }
    return axiosInstance
        .get(`/order/${storeId}?${qs_1.default.stringify(queryParams, { indices: false })}`)
        .then((response) => response.data);
}
exports.fetchOrdersByStoreId = fetchOrdersByStoreId;
/**
 * @deprecated The method should not be used.
 * Please use function fetchOrderByTokenMintAndShopId below
 */
async function fetchOrderByTokenMint(axiosInstance, mintAddress) {
    return axiosInstance.get(`/order/mint/${mintAddress}`).then((response) => response.data);
}
exports.fetchOrderByTokenMint = fetchOrderByTokenMint;
async function fetchOrderByTokenMintAndShopId(axiosInstance, mintAddress, shopId) {
    console.log(`CandyShop: fetching orders by shop address=${shopId}, mintAddress=${mintAddress}`);
    return axiosInstance
        .get(`/order/mint/${mintAddress}/shop/${shopId}`)
        .then((response) => response.data);
}
exports.fetchOrderByTokenMintAndShopId = fetchOrderByTokenMintAndShopId;
async function fetchOrdersByStoreIdAndWalletAddress(axiosInstance, storeId, walletAddress) {
    console.log(`CandyShop: fetching orders by shop address=${storeId}, walletAddress=${walletAddress}`);
    // handles pagination internally
    const limit = 10;
    let offset = 0;
    let resCount = null;
    let orders = [];
    while (resCount === null || resCount == limit) {
        const page = await axiosInstance
            .get(`/order/${storeId}?offset=${offset}&limit=${limit}&filterArr[]=${JSON.stringify({
            side: 1,
            status: 0,
            walletAddress
        })}`)
            .then((response) => { var _a; return (_a = response.data) === null || _a === void 0 ? void 0 : _a.result; });
        resCount = page.length;
        offset = offset + limit;
        orders = orders.concat(page);
    }
    return orders;
}
exports.fetchOrdersByStoreIdAndWalletAddress = fetchOrdersByStoreIdAndWalletAddress;
